import { createSlice } from "@reduxjs/toolkit";
import { ReactSelectOption, State } from "../../../../types/Constants";
import {
  BaselineProjectInfoType,
} from "../../../../types/Project";

const initialState: Omit<
  BaselineProjectInfoType,
  "state" | "projectType" | "constructionType" | "projectLeadId"
> & {
  state: State;
  projectLeadId: ReactSelectOption;
  projectType: ReactSelectOption;
  constructionType: ReactSelectOption;
  neighborhood?: { label: string; value: string };
  // neighborhood?: string
} = {
  name: "",
  location: {
    address1: "",
    address2: "",
    city: "",
    state: "",
    postalCode: "",
    country: "",
    lat: 0,
    lng: 0,
    placeId: "",
  },
  address: "",
  city: "",
  state: { name: "Select State", abbreviation: "Select State" },
  zipCode: "",
  projectType: { label: "Select Project Type", value: "Select Project Type" },
  constructionType: {
    label: "Select Construction Type",
    value: "Select Construction Type",
  },
  squareFeet: 0,
  goals: [],
  projectLeadId: { label: "Select Project Lead", value: "Select Project Lead" },
};

export const BaselineProjectInfoSlice = createSlice({
  name: "baseline-project-info",
  initialState,
  reducers: {
    clearProjectBaselineInfo: (state) => initialState,
    setProjectBaselineInfo(state, { payload }) {
      return { ...state, ...payload };
    },
  },
});

export const { setProjectBaselineInfo, clearProjectBaselineInfo } =
  BaselineProjectInfoSlice.actions;

export default BaselineProjectInfoSlice.reducer;
